import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articleMeta } from "@/mocks/articles";

export default function ArticleSection() {
  const { t } = useTranslation();

  return (
    <section id="articles" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("home.article.title")}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("home.article.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articleMeta.map((meta) => (
            <Link
              key={meta.slug}
              to={`/guides/${meta.slug}`}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-white transition-transform hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={meta.image}
                  alt={t(`article.content.${meta.slug}.title`)}
                  title={`${t(`article.content.${meta.slug}.title`)} — ${t("common.siteName")}`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-3">
                  <span className="inline-flex w-fit rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
                    {t(`article.content.${meta.slug}.tag`)}
                  </span>
                  <span className="text-xs text-foreground-400">{meta.date}</span>
                </div>
                <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950">
                  {t(`article.content.${meta.slug}.title`)}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                  {t(`article.content.${meta.slug}.subtitle`)}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-4">
                  <span className="text-xs text-foreground-400">
                    {t("home.article.updated")}: {meta.date}
                  </span>
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors group-hover:text-primary-700">
                    {t("home.article.readMore")}
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}